import { FloatingFilterButton } from '~shared/ui/floating-filter-button';

import {
  BusinessSelect,
  StatusSelect,
  StoreSelect,
} from './orders-filter-fields';

type Props = {
  activeCount: number;
  onApply: () => void;
  onClear: () => void;
};

export function OrdersFiltersMobile({ activeCount, onApply, onClear }: Props) {
  return (
    <FloatingFilterButton
      activeCount={activeCount}
      onApply={onApply}
      onClear={onClear}
    >
      <BusinessSelect />
      <StoreSelect />
      <StatusSelect />
    </FloatingFilterButton>
  );
}
